import React from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "@/components/home/HeroSection";
import StatsSection from "@/components/home/StatsSection";
import ServicesPreview from "@/components/home/ServicesPreview";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Helmet>
        <title>PIERRE AFFRETEMENT - Vichy 03</title>
        <link rel="canonical" href="https://pierreaffretement.fr/" />
        <meta name="description" content="Commissionnaire de transport, spécialiste de l'organisation de transports de marchandises en France et à l'international." />
      </Helmet>
      <HeroSection />
      <StatsSection />
      <ServicesPreview />
    </div>
  );
}
